const isKeywordsInDescription = (keyWords, description) =>
  keyWords.some((word) =>
    description.find((rule) => rule.text && rule.text.toLowerCase().includes(word)),
  );

export default isKeywordsInDescription;
